import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Customization = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Customisation Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=""
                />
                <meta
                    name="keywords"
                    content=""
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Customization & Configuration Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/customization.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service bottom">
                            <p className="prose-lg wow fadeUp">
                                <strong>Salesforce customization and configuration services </strong>Our goal is to tailor Salesforce products to meet the unique sales, marketing, and service needs of your business. With over a decade of experience delivering CRM services since 2010, Codezix helps companies configure and customize their Salesforce systems to boost revenue and enhance sales productivity.
                            </p>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>How We Tailor the Salesforce Platform</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix’s team is ready to tailor your Salesforce solution in two ways, each differing in the level of impact on the platform, complexity, and costs.</p>
                            </div>
                        </div>

                        <div className="selesforce-services mt-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="plateform">
                                        <img src="https://www.scnsoft.com/colorful-icons/configuration.svg" alt="" />
                                        <h3 className="mt-4">Level 1. Salesforce configuration</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We recommend choosing Salesforce configuration when modifying the UI, data model, and business logic of your Salesforce solution using point-and-click tools is sufficient to meet your needs. Possible configurations include creating reports and dashboards, workflows and validation rules, tabs and apps (collections of tabs grouped for user presentation) with default Salesforce tools, installing AppExchange applications, and more.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="plateform">
                                        <img src="https://www.scnsoft.com/colorful-icons/custom-development.svg" alt="" />
                                        <h3 className="mt-4">Level 2. Salesforce customization</h3>
                                        <p className="wow fadeUp prose-lg">
                                            If you require specific Salesforce functionality that cannot be achieved through configuration, we offer Salesforce customization. This involves modifying your solution with code. Customization is necessary when:
                                        </p>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> You have large volumes of data and complex business logic that cannot be fully addressed with Salesforce's default functionality.</li>
                                                <li className="wow fadeUp prose-lg">Default or configured reports/dashboards do not provide a complete view of the data needed to accurately reflect your business processes.</li>
                                                <li className="wow fadeUp prose-lg">Integrating with external systems (such as ERP, e-commerce platforms, etc.) is essential for your business operations.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix top">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is proud to be recognized as a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in IT business.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in CRM services.</li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board.</li>
                                    <li className="wow fadeUp prose-lg">Expertise across industries such as manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                </ul>
                            </div>
                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product ">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Products We Implement</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix’s Salesforce team is ready to support you in implementing:</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/customization#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='achieve-project mb-4'>
                            <button className="prose-md">What makes Codezix different</button>
                            <h3>We ensure project success, no matter the circumstances</h3>
                            <p>Codezix does not pass mere project administration off as project management, which, unfortunately, is a common practice in the market. We practice real project management, ensuring project success for our clients no matter what.</p>
                            <Link to="/"> <button>See how we do it&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Configurations and Customizations Delivered by Codezix</h2>
                                <p className="wow fadeUp prose-lg text-left">Depending on your business needs, the complexity of your internal processes, and the volume of data you handle, we customize your Salesforce solution using default tools or through custom development on the Lightning Platform.</p>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-1.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We enhance your Salesforce solution by adding custom objects, fields, and records to capture data that goes beyond its standard functionality. For example, if we were customizing the Salesforce solution for a real estate company, whose need to track properties for sale isn’t covered by default Salesforce objects, we would introduce a custom object called “Property” with tailored fields to meet their specific requirements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-2.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We integrate business rules into your CRM using Apex triggers, enabling the automation of sales, service, and marketing processes. This makes them more efficient to monitor and manage.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-3.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We automate daily and recurring tasks, such as sending email notifications and assigning follow-up tasks, using workflows and Apex triggers. By utilizing workflow tools like Workflow Rules, Process Builder, or Apex code, we help boost employee productivity and eliminate a substantial amount of manual work.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-4.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We enable bulk data processing, a best practice for supporting an expanding Salesforce solution with tasks such as mass record updates, weekly lead evaluations, and more. This includes loading and deleting large datasets in Salesforce and performing multiple record updates using bulk triggers.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-5.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We create custom email templates that allow you to design emails with your desired look using a custom style sheet. With Salesforce’s customization capabilities, you can enable custom style sheets and manage email attachments more easily.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-6.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We design custom reports and dashboards for sales, marketing, and service teams when they require deeper insights into specific metrics that can't be accurately captured with Salesforce’s standard reporting functionality. Additionally, we enhance these custom reports by incorporating Apex code to retrieve and display the data on the report page.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-7.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We integrate Einstein AI into your Salesforce solution and customize it to meet your specific needs. AI-powered features provide valuable insights for sales, marketing, and service, such as recommending the next best sales actions, scoring the potential success of marketing emails, and automatically classifying and routing service cases.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-8.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We integrate Salesforce with third-party systems, such as ERP, e-commerce platforms, social media, and email, to enhance collaboration within your organization. Using REST/SOAP API web services, along with default tools like Files Connect or custom-built solutions, we ensure seamless integration that supports your business needs.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>CRM Customization Benefits</h2>
                                    <p className="wow fadeUp prose-lg text-left">Codezix knows how Salesforce customization can drive success for your business. Here’s a list of benefits you gain by tailoring your solution to meet your specific needs:</p>
                                </div>

                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"><strong>Revenue increase.</strong> According to the Salesforce Relationship Survey, using Salesforce can boost a deal's win rate by up to 24%. With Salesforce customizations, we can help you achieve even greater results. Our customizations ensure that all CRM processes are optimized, necessary integrations are in place, and customer communication is both efficient and personalized—factors that directly contribute to a significant increase in revenue.</li>
                                        <li className="wow fadeUp prose-lg"><strong>High ROI.</strong> According to a Nucleus Research study, every dollar invested in CRM can return up to $8.71 in sales revenue. At Codezix, we've seen even higher ROI from our successful Salesforce customization projects.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Productivity increase. </strong> According to the Salesforce Relationship Survey, using Salesforce can boost sales productivity by up to 25%. Salesforce customization by Codezix, designed with user convenience in mind, can drive even more significant productivity growth.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Challenges We Solve</h2>
                                    <p className="wow fadeUp prose-lg text-left">We develop solutions to address various challenges within Salesforce, including:</p>
                                </div>

                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"><strong>Low win rates due to an inconsistent sales process.</strong> We help enhance or completely transform your sales process using Salesforce Sales Cloud. To streamline process automation, we recommend leveraging Salesforce's built-in features or implementing custom code-based solutions. This approach enables the creation of a clear, well-organized sales process, providing visibility into its execution and guiding sales representatives toward successfully closing deals. With Salesforce consulting, businesses can achieve a 26% increase in win rates and a 28% boost in sales revenue.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Inefficient customer service caused by prolonged case resolution times.</strong> We can assist you in enhancing your customer service quality by utilizing Salesforce Service Cloud's built-in or customized case management features. With our guidance, you’ll learn how to effectively use its automated case assignment, prioritization, and escalation tools to boost your service agents' productivity, leading to a 31% faster case resolution rate.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Ineffective lead conversion processes resulting in low conversion rates. </strong> We demonstrate how to boost your lead conversion rates by designing effective omni-channel marketing campaigns and leveraging Salesforce Marketing Cloud's digital advertising capabilities. Our team will guide you in developing tailored customer communication strategies, enabling you to engage with a broad audience while delivering highly personalized experiences. This approach can result in a 30% improvement in lead conversion rates.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Get Your Salesforce Needs Addressed</h3>
                                            <p className="prose-lg wow fadeUp">Looking to maximize the value of your sales, customer service, and marketing efforts? Our team can provide expert guidance on how to achieve it.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button> Turn to our experts </button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Customization;